/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ReportDashboardLayoutItem } from './ReportDashboardLayoutItem';
import type { ReportFunnelStatusFunnelFilters } from './ReportFunnelStatusFunnelFilters';
import type { ReportWidgetAccentColor } from './ReportWidgetAccentColor';
import type { ReportWidgetValidation } from './ReportWidgetValidation';
/**
 * Persisted funnel status funnel widget instance.
 */
export type ReportFunnelStatusFunnelWidgetInstance = {
    /**
     * Stable widget instance identifier.
     */
    id: string;
    /**
     * Discriminator for the funnel status funnel widget.
     */
    kind: ReportFunnelStatusFunnelWidgetInstance.kind;
    /**
     * Optional user-facing title override.
     */
    title?: string;
    /**
     * Optional short badge label shown on the widget card.
     */
    label?: string;
    /**
     * Optional semantic accent color used to tint the widget card and badge.
     */
    color?: ReportWidgetAccentColor;
    /**
     * Saved layout metadata for the widget instance.
     */
    layout: ReportDashboardLayoutItem;
    /**
     * Validation result resolved from the current tenant state.
     */
    validation?: ReportWidgetValidation;
    /**
     * Saved filters for the funnel status funnel widget.
     */
    filters: ReportFunnelStatusFunnelFilters;
};
export namespace ReportFunnelStatusFunnelWidgetInstance {
    /**
     * Discriminator for the funnel status funnel widget.
     */
    export enum kind {
        FUNNEL_STATUS_FUNNEL = 'FUNNEL_STATUS_FUNNEL',
    }
}

